import seeds from './seeds';

export const fetchQuestion = () => new Promise(resolve => resolve(seeds));



// WEBPACK FOOTER //
// ./client/modules/debate/data/index.js